import { api } from 'shared/api'
import { AiStepStatsSchemas } from 'shared/api/requests/aiStepStats/schemas'

export const AiStepStatsApi = {
  contentStat: api.account.createGet({
    url: '/aiAgentStatistics/contentStat',
    schemas: AiStepStatsSchemas.get,
    scope: 'ai',
    section: 'ai_agent_stats',
  }),
}
